module.exports = __webpack_public_path__ + "static/media/wave-triangle.c9d38c07.svg";